module.exports = __webpack_public_path__ + "static/img/other4.eca30c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other4.png
// module id = 91Za
// module chunks = 1